import { MODELS } from '@/lib/ai/models';
import { MRGE_GITHUB_REPO_OWNER } from '@/lib/constants';

export const CHAT_MODEL_PROVIDER_ORDER = ['OpenAI', 'Anthropic', 'Moonshot', 'Google'] as const;

export type ChatModelProvider = (typeof CHAT_MODEL_PROVIDER_ORDER)[number];

export type ChatModelOption = {
  value: string;
  label: string;
  provider: ChatModelProvider;
  keywords: string[];
};

export const CHAT_MODEL_OPTIONS: ChatModelOption[] = [
  {
    value: MODELS.OPENAI.GPT_5_3_CODEX,
    label: 'GPT-5.3 Codex',
    provider: 'OpenAI',
    keywords: ['gpt', 'openai', '5.3', 'codex', 'code'],
  },
  {
    value: MODELS.OPENAI.GPT_6_LUNA,
    label: 'GPT-6 Luna',
    provider: 'OpenAI',
    keywords: ['gpt', 'openai', '6', 'luna', 'reasoning'],
  },
  {
    value: MODELS.OPENAI.GPT_5_NANO,
    label: 'GPT-5 Nano',
    provider: 'OpenAI',
    keywords: ['gpt', 'openai', '5', 'nano', 'fast'],
  },
  {
    value: MODELS.ANTHROPIC.CLAUDE_SONNET_5,
    label: 'Claude Sonnet 5',
    provider: 'Anthropic',
    keywords: ['claude', 'sonnet', 'anthropic', '5'],
  },
  {
    value: MODELS.MOONSHOT.KIMI_K2_6,
    label: 'Kimi K2.6',
    provider: 'Moonshot',
    keywords: ['kimi', 'moonshot', 'k2.6', 'k2-6', 'reasoning'],
  },
  {
    value: MODELS.MOONSHOT.KIMI_K2P5,
    label: 'Kimi K2.5',
    provider: 'Moonshot',
    keywords: ['kimi', 'moonshot', 'k2.5', 'reasoning'],
  },
  {
    value: MODELS.GOOGLE_VERTEX.GEMINI_3_7_FLASH,
    label: 'Gemini 3.7 Flash',
    provider: 'Google',
    keywords: ['gemini', 'google', '3.7', 'flash', 'thinking'],
  },
  {
    value: MODELS.GOOGLE_VERTEX.GEMINI_3_1_FLASH_LITE,
    label: 'Gemini 3.1 Flash-Lite',
    provider: 'Google',
    keywords: ['gemini', 'google', '3.1', 'flash', 'flash-lite', 'lite', 'preview', 'thinking'],
  },
];

export const CHAT_MODEL_VALUES = new Set(CHAT_MODEL_OPTIONS.map((model) => model.value));
export const CHAT_MODEL_STORAGE_KEY = 'chat-model';
export const CHAT_DEFAULT_MODEL = MODELS.OPENAI.GPT_6_LUNA;
// Local dev often runs without Gemini/Vertex credentials, so keep OpenAI Codex as the
// fallback to avoid breaking chat requests when developers are working offline.
export const CHAT_LOCAL_DEV_FALLBACK_MODEL = MODELS.OPENAI.GPT_5_3_CODEX;

export function isChatModelSelectionEnabled(owner: string | null | undefined): boolean {
  return owner?.trim().toLowerCase() === MRGE_GITHUB_REPO_OWNER;
}
